import { useContext } from "react"
import ModalContext from "../contexts/ModalContext/context"
import { closeModal, openModal } from "../contexts/ModalContext/actions"
import { ModalState } from "../contexts/ModalContext/types"

export const useModal = () => {
  const { modal, dispatch } = useContext(ModalContext)

  const closeModalElem = () => {
    dispatch(closeModal())
  }

  const openModalElem = (data: ModalState) => {
    dispatch(openModal(data))
  }

  return {
    closeModal: closeModalElem,
    openModal: openModalElem,
    isOpen: !!modal.content
  }
}
